import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  firstLogin: false,
  loggedIn: false,
  isDoctor: false,
  paymentSetup: true,
  token: "",
  slug: "",
  isDev: false,
  notifCount: 0,
  docsUploaded: false,
  country: "MY", // Default to Malaysia for existing users
  currencyPreset: null, // Currency preset from overview endpoint
};

export const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    setFirstLogin: (state) => {
      state.firstLogin = true;
    },
    setLoggedIn: (state, action) => {
      state.token = action.payload.token;
      state.slug = action.payload.slug;
      state.loggedIn = true;
      // Set country if provided in login response
      if (action.payload.country) {
        state.country = action.payload.country;
      }
      // Bind the role to the session that was actually authenticated. Without this,
      // isDoctor only ever reflects a pre-login role-picker click and goes stale on reload.
      if (typeof action.payload.isDoctor === "boolean") {
        state.isDoctor = action.payload.isDoctor;
      }
    },
    setLoggedOut: (state) => {
      console.log("setlogged out");
      // Clear all authentication-related data
      state.loggedIn = false;
      state.token = "";
      state.slug = "";
      state.paymentSetup = true;
      state.docsUploaded = false;
      state.notifCount = 0;
      state.currencyPreset = null;
      // Keep isDoctor and country as they might be needed for the login screen
    },
    setIsDoctor: (state, action) => {
      state.isDoctor = action.payload;
    },
    setUserToken: (state, action) => {
      state.token = action.payload;
    },
    setPaymentSetup: (state, action) => {
      state.paymentSetup = action.payload;
    },
    setIsDev: (state, action) => {
      state.isDev = action.payload;
    },
    setNotifCount: (state, action) => {
      state.notifCount = action.payload;
    },
    setDocsUploaded: (state, action) => {
      state.docsUploaded = action.payload;
    },
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    setCurrencyPreset: (state, action) => {
      state.currencyPreset = action.payload;
    },
  },
});

export const {
  setFirstLogin,
  setLoggedIn,
  setLoggedOut,
  setIsDoctor,
  setUserToken,
  setPaymentSetup,
  setIsDev,
  setNotifCount,
  setDocsUploaded,
  setCountry,
  setCurrencyPreset,
} = user.actions;

export default user.reducer;
